import toast from "react-hot-toast";
import React from "react";
import { CheckCircle2, XCircle, ShoppingCart, Trash2, X } from "lucide-react";

const baseBox =
  "flex items-start gap-4 rounded-2xl border-2 px-5 py-4 shadow-2xl backdrop-blur-md bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 animate-in slide-in-from-top-2";

const iconBase =
  "flex-shrink-0 inline-flex h-10 w-10 items-center justify-center rounded-full border-2 shadow-lg";

export function notifySuccess(title, description) {
  return toast.custom(
    (t) => (
      <div
        className={`${baseBox} border-emerald-500/50 bg-emerald-950/20`}
        style={{
          opacity: t.visible ? 1 : 0,
          transform: t.visible ? "translateY(0)" : "translateY(-10px)",
          transition: "all 300ms cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      >
        <div className={`${iconBase} border-emerald-500 bg-emerald-500/20 text-emerald-400`}>
          <CheckCircle2 className="w-5 h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-white font-bold text-base leading-tight mb-1">{title}</div>
          {description ? (
            <div className="text-emerald-100/80 text-sm leading-relaxed break-words">
              {description}
            </div>
          ) : null}
        </div>
        <button
          onClick={() => toast.dismiss(t.id)}
          className="flex-shrink-0 text-gray-400 hover:text-white transition-colors p-1 rounded-full hover:bg-gray-700/50"
          aria-label="Dismiss notification"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    ),
    { duration: 3000, position: "top-right" }
  );
}

export function notifyError(title, description) {
  return toast.custom(
    (t) => (
      <div
        className={`${baseBox} border-red-500/50 bg-red-950/20`}
        style={{
          opacity: t.visible ? 1 : 0,
          transform: t.visible ? "translateY(0)" : "translateY(-10px)",
          transition: "all 300ms cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      >
        <div className={`${iconBase} border-red-500 bg-red-500/20 text-red-400`}>
          <XCircle className="w-5 h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-white font-bold text-base leading-tight mb-1">{title}</div>
          {description ? (
            <div className="text-red-100/80 text-sm leading-relaxed break-words">
              {description}
            </div>
          ) : null}
        </div>
        <button
          onClick={() => toast.dismiss(t.id)}
          className="flex-shrink-0 text-gray-400 hover:text-white transition-colors p-1 rounded-full hover:bg-gray-700/50"
          aria-label="Dismiss notification"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    ),
    { duration: 3500, position: "top-right" }
  );
}

export function notifyCartAdd(productName) {
  return toast.custom(
    (t) => (
      <div
        className={`${baseBox} border-teal-500/50 bg-teal-950/20`}
        style={{
          opacity: t.visible ? 1 : 0,
          transform: t.visible ? "translateY(0)" : "translateY(-10px)",
          transition: "all 300ms cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      >
        <div className={`${iconBase} border-teal-500 bg-teal-500/20 text-teal-400`}>
          <ShoppingCart className="w-5 h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-white font-bold text-base leading-tight mb-1">Added to Cart</div>
          <div className="text-teal-100/80 text-sm leading-relaxed break-words">
            {productName}
          </div>
        </div>
        <button
          onClick={() => toast.dismiss(t.id)}
          className="flex-shrink-0 text-gray-400 hover:text-white transition-colors p-1 rounded-full hover:bg-gray-700/50"
          aria-label="Dismiss notification"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    ),
    { duration: 2500, position: "top-right" }
  );
}

export function notifyCartRemove(productName) {
  return toast.custom(
    (t) => (
      <div
        className={`${baseBox} border-orange-500/50 bg-orange-950/20`}
        style={{
          opacity: t.visible ? 1 : 0,
          transform: t.visible ? "translateY(0)" : "translateY(-10px)",
          transition: "all 300ms cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      >
        <div className={`${iconBase} border-orange-500 bg-orange-500/20 text-orange-400`}>
          <Trash2 className="w-5 h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-white font-bold text-base leading-tight mb-1">Removed from Cart</div>
          <div className="text-orange-100/80 text-sm leading-relaxed break-words">
            {productName}
          </div>
        </div>
        <button
          onClick={() => toast.dismiss(t.id)}
          className="flex-shrink-0 text-gray-400 hover:text-white transition-colors p-1 rounded-full hover:bg-gray-700/50"
          aria-label="Dismiss notification"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    ),
    { duration: 2500, position: "top-right" }
  );
}




